import { createUploadthingClient } from '@travel-planner/uploadthing/client';

// Header name is inlined rather than imported: the server-side constant lives
// next to the token hashing helpers, and that module imports `node:crypto`,
// which Vite cannot bundle for the browser. Keep this string in sync with
// `FINAL_CLIENT_FORM_TOKEN_HEADER` in
// packages/shared/src/schemas/final-client-details.ts.
const FINAL_CLIENT_FORM_TOKEN_HEADER = 'x-final-client-form-token';

const apiUrl = `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}/api/uploadthing`;

// The public Final Client Details Form has no Clerk session — the share token
// IS the credential — so its uploader carries the token in a header. The server
// resolves it in `apps/api/src/shared/uploadthing.ts`.
//
// The token is read at request time from this module-level holder rather than
// baked into the client, because the client is created once and the page learns
// its token from the URL after mount.
let shareToken: string | null = null;

export const setFinalClientFormUploadToken = (token: string | null) => {
  shareToken = token;
};

export const { useUploadThing: useFinalClientFormUpload } =
  createUploadthingClient({
    apiUrl,
    // No signed-in user on this surface.
    getAuthToken: async () => null,
    getExtraHeaders: () =>
      shareToken ? { [FINAL_CLIENT_FORM_TOKEN_HEADER]: shareToken } : null,
  });
